import React from "react";
import Dish1 from "../../../../resources/imgs/assessment/dishes/dish1.svg";
import Dish2 from "../../../../resources/imgs/assessment/dishes/dish2.svg";
import Dish3 from "../../../../resources/imgs/assessment/dishes/dish3.svg";
import Dish4 from "../../../../resources/imgs/assessment/dishes/dish4.svg";
import Dish5 from "../../../../resources/imgs/assessment/dishes/dish5.svg";
import Dish6 from "../../../../resources/imgs/assessment/dishes/dish6.svg";
import "./style.css";

export default function ManCard(props) {
  const Dishes = [Dish1, Dish2, Dish3, Dish4, Dish5, Dish6];
  const dishNames = ["Fish", "Steak", "Chicken", "Pasta", "Vegetarian", "Lamb"];
  
  // CORRECTED dish mapping based on actual SVG file contents
  // After investigation, the SVG files are in a different order than expected
  const actualDishNames = ["Fish", "Chicken", "Pasta", "Steak", "Vegetarian", "Lamb"];
  
  // Debug log to see what dish array ManCard receives
  console.log(`🔍 ManCard for ${props.name}: dish array [${props.dish.join(', ')}]`);
  console.log(`  - 1st choice: index ${props.dish[0]} → shows ${actualDishNames[props.dish[0]]}`);
  console.log(`  - 2nd choice: index ${props.dish[1]} → shows ${actualDishNames[props.dish[1]]}`); 
  console.log(`  - Detested: index ${props.dish[2]} → shows ${actualDishNames[props.dish[2]]}`);
  
  return (
    <div className="mancard-contaienr">
      <img className="man-img" src={props.img}></img>
      <div className="mancard-body">
        <div className="mancard-name">{props.name}</div>
        <div className="mancard-food">
          <div className="mancard-order">1st choice</div>
          <img key={`${props.name}-first-${props.dish[0]}`} src={Dishes[props.dish[0]]}></img>
        </div>
        <div className="mancard-food">
          <div className="mancard-order">2nd choice</div>
          <img key={`${props.name}-second-${props.dish[1]}`} src={Dishes[props.dish[1]]}></img>
        </div>
        <div className="mancard-food">
          <div className="mancard-order">Detested</div>
          <img key={`${props.name}-detested-${props.dish[2]}`} src={Dishes[props.dish[2]]}></img>
        </div>
        <div className="mancard-food"></div>
        <div className="mancard-food"></div>
      </div>
    </div>
  );
}
